import { CheckboxCardActionProps } from "@payment-ui/components/secure-card-info/SecureCardInfo";
import React, { useCallback, useState } from "react";
import { SECURE_CARD_INFO_ACTION } from "@payment-ui/interfaces";

import { TEXTS } from "@payment-ui/constants/index";

interface UseCardHalfCardProps {
    onSecureCardInfoClickAction?: (action: SECURE_CARD_INFO_ACTION) => void;
    onKnowMoreTokenizationClickAction?: () => void;
}

interface UseCardHalfCardReturn {
    showSecureCardInfo: SecureCardHalfCardState;
    onSecureCardInfoClick: (e: React.MouseEvent) => void;
    closeSecureCardInfo: VoidFunction;
    showSecureCardHalfCardWithActions: (primaryAction: VoidFunction, secondaryAction: VoidFunction) => void;
}

interface SecureCardHalfCardState {
    show: boolean;
    actions?: {
        primaryAction: CheckboxCardActionProps;
        secondaryAction?: CheckboxCardActionProps;
    };
}

export const useCardHalfCard = (props: UseCardHalfCardProps): UseCardHalfCardReturn => {
    const { onSecureCardInfoClickAction, onKnowMoreTokenizationClickAction } = props;
    const [showSecureCardInfo, setShowSecureCardInfo] = useState<SecureCardHalfCardState>({ show: false });

    // secure card actions
    const onSecureCardInfoClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            typeof onKnowMoreTokenizationClickAction === "function" && onKnowMoreTokenizationClickAction();

            setShowSecureCardInfo({
                show: true,
                actions: {
                    primaryAction: {
                        text: TEXTS.GOT_IT,
                        onClick: (): void => {
                            typeof onSecureCardInfoClickAction === "function" &&
                                onSecureCardInfoClickAction(SECURE_CARD_INFO_ACTION.GOT_IT);
                            setShowSecureCardInfo({ show: false });
                        },
                    },
                },
            });
        },
        [onKnowMoreTokenizationClickAction, onSecureCardInfoClickAction],
    );

    const closeSecureCardInfo = useCallback(() => {
        typeof onSecureCardInfoClickAction === "function" && onSecureCardInfoClickAction(SECURE_CARD_INFO_ACTION.CLOSE);
        setShowSecureCardInfo({ show: false });
    }, [onSecureCardInfoClickAction]);

    const showSecureCardHalfCardWithActions = useCallback(
        (primaryAction: () => void, secondaryAction: () => void) => {
            setShowSecureCardInfo({
                show: true,
                actions: {
                    primaryAction: {
                        text: TEXTS.SAVE_CARD_AND_PAY,
                        showArrow: true,
                        onClick: (): void => {
                            typeof onSecureCardInfoClickAction === "function" &&
                                onSecureCardInfoClickAction(SECURE_CARD_INFO_ACTION.SECURE_CARD_AND_PAY);
                            primaryAction();
                        },
                    },
                    secondaryAction: {
                        text: TEXTS.PAY_WITHOUT_SAVING,
                        onClick: (): void => {
                            typeof onSecureCardInfoClickAction === "function" &&
                                onSecureCardInfoClickAction(SECURE_CARD_INFO_ACTION.SKIP_FOR_NOW);
                            secondaryAction();
                        },
                    },
                },
            });
        },
        [onSecureCardInfoClickAction],
    );

    return {
        showSecureCardInfo,
        onSecureCardInfoClick,
        closeSecureCardInfo,
        showSecureCardHalfCardWithActions,
    };
};
